import script from "./OTPInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPInput.vue?vue&type=script&setup=true&lang=js"

import "./OTPInput.vue?vue&type=style&index=0&id=a98621d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98621d4"]])

export default __exports__